import { render, staticRenderFns } from "./Contrato.vue?vue&type=template&id=826fa20c&scoped=true&"
import script from "./Contrato.vue?vue&type=script&lang=js&"
export * from "./Contrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826fa20c",
  null
  
)

export default component.exports